export default __webpack_public_path__ + "static/media/default-place.166d4921.png";